import { Flex } from "antd"
import { ReactComponent as ArrowRight } from "../../assets/images/icon/arrow-right.svg"

interface IProps {
    title: string | React.ReactNode;
    onClick?: Function;
    content?: string | React.ReactNode;
    styles?: { container?: React.CSSProperties, title?: React.CSSProperties, content?: React.CSSProperties, arrowRight?: React.CSSProperties }
    iconRender?: React.ReactNode
}

const BasicInfoRow = ({ title, onClick, content, styles, iconRender }: IProps) => {
    return <>
        <Flex
            onClick={() => onClick?.()}
            className="body/b3"
            style={{ padding: '14px 0 14px 12px', cursor: onClick ? 'pointer' : 'auto', justifyContent: 'space-between', alignItems: 'center', ...styles?.container }}>
            <div style={{ color: 'var(--secondarys800)', ...styles?.title }}>{title}</div>
            {content
                ? <div style={{ ...styles?.content }}>{content}</div>
                : iconRender
                    ? iconRender
                    : <ArrowRight width={16} height={16} stroke="#737373" style={{ ...styles?.arrowRight }} />}
        </Flex>
    </>
}

export { BasicInfoRow }